import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/b2b2006.css';
import BgTop from '../images/Event/b2b2006/bg_top.png';
import BgInquiry from '../images/Event/b2b2006/bg_inquiry.png';
import InfoPrivacy from '../images/Event/b2b2006/info_privacy.png';
import * as Common from '../components/Common';
import { Actions } from '../components/Actions';

class B2b2006 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenPopup: false,
      company: "",
      name: "",
      tel: ""
    };
  }

  componentDidMount() {
  }

  /**
   * 제출하기
   */
  _doSubmit() {
    var company = this.state.company;
    var name = this.state.name;
    var tel = this.state.tel;
    var isAgree = this.state.isAgree;

    if(!company) {
      Actions.alertOpen({msg: "기업명을 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!name) {
      Actions.alertOpen({msg: "담당자명을 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!tel) {
      Actions.alertOpen({msg: "담당자 연락처를 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(Common.checkExp(tel)) {
      Actions.alertOpen({msg: "숫자만 입력해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    if(!Common.isPhoneNumberValidation(tel)) {
      Actions.alertOpen({msg: "연락처 형식이 올바르지 않습니다."}, [{type: 'ok', label: '확인'}]);
      return false;
    }

    if(!isAgree) {
      Actions.alertOpen({msg: "개인정보 수집 동의를 체크해주세요."}, [{type: 'ok', label: '확인'}]);
      return;
    }

    Common.callApi("/promotion/b2b2006/submit", "post", {company: company, name: name, tel: tel})
    .then(result => {
      if(result.resultCode === "success") {
        this.setState({ isOpenPopup: true });
      } else {
        Actions.alertOpen({msg: result.resultMessage}, [{type: 'ok', label: '확인'}]);
      }
    });
  }

  _renderPopup() {
    return (
      <div className="popupArea" onClick={() => {window.location.reload()}}>
        <div className="popupContentsArea">
        </div>
      </div>
    )
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont b2b2006" style={{background: '#14191b'}}>
              <div id="contents" style={{background: '#14191b'}}>
                <div><img src={BgTop} style={{width: '100%'}} /></div>
                <div className="info-cont" style={{textAlign: 'center'}}>
                  <div style={{width: '100%', display: 'table', marginTop: '30px'}}>
                    <div style={{display: 'table-cell', textAlign: 'center'}}>
                      <div><img src={BgInquiry} style={{width: "80%"}} /></div>
                      <input type="text" placeholder="기업명" onChange={(e) => this.setState({company: e.target.value})} />
                      <input type="text" placeholder="담당자명" onChange={(e) => this.setState({name: e.target.value})} />
                      <input type="tel" placeholder="담당자 연락처" maxLength="11" onChange={(e) => this.setState({tel: e.target.value})} />
                      <img className="infoPrivacy" src={InfoPrivacy} />
                    <p className="agreeArea">
                      <input type="checkbox" id="isAgree" onChange={e => this.setState({ isAgree: !this.state.isAgree })}  />
                      <label htmlFor="isAgree">&nbsp;&nbsp;개인정보 수집 및 이용에 관해 동의합니다.</label>
                    </p>
                      <button className="submit" onClick={() => this._doSubmit()}>제출하기</button>
                    </div>
                  </div>
                </div>

                <p style={{fontSize: "12px", textAlign: "center", color: "#a7a8a8", paddingTop: "5%", paddingBottom: "10%"}}>
                  ※ 입력 후 3일 이내에 담당자가 연락드립니다. 
                </p>

                <p style={{fontSize: "13px", textAlign: "center", color: "#fff", paddingBottom: "8%"}}>
                  (주)티스터디컴퍼니&nbsp;&nbsp;&nbsp;&nbsp;tsc_head@toz.co.kr
                </p>
              </div>

              {this.state.isOpenPopup ? this._renderPopup() : ""}
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default B2b2006;